jQuery(document).ready(function ($) {

    //$("body.blog #Filters .filters_wrapper ul li:last-child:last").css("content", " ");
    $("div#Action_bar ul.contact_details li.phone:nth-child(3) i").removeClass('icon-phone').addClass('icon-whatsapp');

});